import {Component, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ProductProviderEnum, ProductProviderMapping} from '@app/marketplace/core/enum/productProvider';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-amazon-wizard',
  templateUrl: './amazon-wizard.component.html',
  styleUrls: ['./amazon-wizard.component.css'],
  providers: [DeviceDetectorService]
})
export class AmazonWizardComponent implements OnInit {

  @Input()top: number;
  @Input()left: number;

  @Input()
  provider$: Observable<ProductProviderEnum>;
  ProductProviderEnum = ProductProviderEnum;
  ProductProviderMapping = ProductProviderMapping;

  constructor(
    public activeModal: NgbActiveModal,
    private store: Store,
    @Inject(DOCUMENT) private document,
    @Inject(PLATFORM_ID) private platformId,
    private deviceService: DeviceDetectorService) {

  }

  async ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      let top = 90;
      if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
        top += 12;
      }
      this.document.getElementsByClassName('amazon-dialog-modal')[0].style.top = top + 31 + 'px';
      this.document.getElementsByClassName('amazon-dialog-modal')[0].style.left = this.left + 5 + 'px';
    }
  }
}


